import { render } from "./AudioRecorder.vue?vue&type=template&id=14ed5d21&scoped=true"
import script from "./AudioRecorder.vue?vue&type=script&lang=js"
export * from "./AudioRecorder.vue?vue&type=script&lang=js"

import "./AudioRecorder.vue?vue&type=style&index=0&id=14ed5d21&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ed5d21"]])

export default __exports__